import { Flex } from '@chakra-ui/react';
import React from 'react';
import './CustomStepperCTA.scss';

interface CustomStepperCTAProps {
  steps: { title: string }[];
  activeStep: number;
}

const CustomStepperCTA = ({ steps, activeStep }: CustomStepperCTAProps) => {
  const totalSteps = steps.length;
  const currentStep = activeStep + 1;

  // Hide stepper on Success page
  if (currentStep > totalSteps) return null;

  return (
    <Flex className={`custom-stepper-cta-container`}>
      <span className={`custom-stepper-cta-text`}>
        {`Step ${currentStep} of ${steps.length}`}
      </span>
    </Flex>
  );
};

export default CustomStepperCTA;
